/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Flashlight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M184.00244,16h-112a16.01833,16.01833,0,0,0-16,16V77.333a16.10105,16.10105,0,0,0,3.2002,9.60058l20.7998,27.7334V224a16.01833,16.01833,0,0,0,16,16h64a16.01833,16.01833,0,0,0,16-16l-.001-109.334,20.80274-27.7334a16.10719,16.10719,0,0,0,3.19824-9.59961V32A16.01833,16.01833,0,0,0,184.00244,16Zm-48,136a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0ZM71.99805,56l-.00537-24H184.00244l.00049,24Z" />
    </Svg>
  );
}

export default Flashlight;
